export const ESRS_CODE_BY_INDEX: Record<number, string> = {
  0: "E1",
  1: "E2",
  2: "E3",
  3: "E4",
  4: "E5",
  5: "S1",
  6: "S2",
  7: "S3",
  8: "S4",
  9: "G1",
  10: "OTHER",
};
